import type { CommonNavContent } from 'client-site-chrome-ui/content/types/commonNavigation';
import type {
  Level1Item,
  Level2Item,
  Level3Item,
} from 'client-site-chrome-ui/types/departmentsNav';

export const transformToDepartmentsProp = (content: CommonNavContent): Level1Item[] => {
  return content.l1_navigation.map((l1) => {
    const displayText =
      l1.l1_display_text || l1.l1_navigation_link[0]?.title || 'no display text for level 1';

    return {
      items: l1.l2_navigation.map((l2): Level2Item => {
        return {
          title:
            l2.l2_display_text || l2.l2_navigation_link[0]?.title || 'no display text for level 2',
          url: l2.l2_navigation_link[0]?.url || '',
          items: l2.l3_navigation.map((l3): Level3Item => {
            return {
              title:
                l3.l3_display_text ||
                l3.l3_navigation_link[0]?.title ||
                'no display text for level 3',
              url: l3.l3_navigation_link[0]?.url || '',
            };
          }),
        };
      }),
      featured: l1.featured,
      title: displayText,
      url: l1.l1_navigation_link[0]?.url || '',
    };
  });
};
